module.exports = [{
      plugin: require('/home/runner/work/portfolio_site/portfolio_site/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Takumi Ogawa - @ogady","short_name":"ogady's site","start_url":"/portfolio_site/","background_color":"#4173B3","theme_color":"#4173B3","display":"minimal-ui","icon":"src/assets/images/ogady_pro.jpg"},
    },{
      plugin: require('/home/runner/work/portfolio_site/portfolio_site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/runner/work/portfolio_site/portfolio_site/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":500},
    },{
      plugin: require('/home/runner/work/portfolio_site/portfolio_site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
